<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <h2 class="modal-header">Bestätigung</h2>
      <p class="modal-text">
        Möchtest du das Los wirklich löschen?
        <br>
        Dieser Vorgang kann nicht rückgängig gemacht werden.
      </p>
      <div class="modal-footer">
        <a class="shopping-cart-button" @click="handleCancel">Abbrechen</a>
        <a class="shopping-cart-button shopping-cart-button--invert" @click="handleAccept">Bestätigen</a>
      </div>
    </div>
  </div>
</template>
  
  <script>
import shoppingCartService from '@/services/shoppingCartService';

export default {
  props: {
    item: Array,
    orderPositionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('closeModal');
    },
    async handleAccept() {
      try {
        let response;
        if(this.item.isFreeLot) {
          response = await shoppingCartService.deleteCouponCode()
        } else {
          response = await shoppingCartService.removeLot(this.item);
        }

        if (response.status.code === 'OK') {
          this.$emit('lotRemoved', this.orderPositionId);
          await shoppingCartService.getShoppingCartData()
          this.$emit('updateCart');
          this.$emit('closeModal');
        } else {
          this.$emit('closeModal');
        }

        return response.status.code;
      } catch (error) {
        console.error('Error while removing lot:', error);
        return false;
      }
    }

  }
};
  </script>

<style lang="scss" scoped>
.modal-overlay {
  font-family: "Aktion Mensch Regular";
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 110;
  background-color: #00000082;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-container {
    background-color: var(--color-white);
    @media (min-width: 900px) {
      min-width: 760px;
    }
    .modal-header {
      padding: 15px 20px;
      border-bottom: 1px solid var(--border-color);
      color: var(--color-red);
      font-family: "Aktion Mensch Bold";
      font-size: 24px;
    }
    .modal-text {
      line-height: 25px;
      padding: 20px;
      color: var(--text-color);
    }

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      padding: 20px;
      a:first-child {
        margin-right: 16px;
      }
    }
  }
}
</style>
